import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ShareIcon from '@mui/icons-material/Share';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { IBalanceFlowProps, IBalanceInstruction } from '../../../../../sp-types/balanceFlowType';
import { ExecutionDealCharacteristics } from '../components/BFDealCharacteristics';
import { ExecutionTable } from '../components/ExecutionTable';
import { useAdminModeStore } from '@components/Stores/EditAdminStore';

export const BalanceFlowInstructions: React.FC<IBalanceFlowProps> = ({
  balanceFlowData,
  // currentStepIndex,
  setCurrentStepIndex,
  updateBalanceFlowData,
}) => {
  const { balanceInstructions } = balanceFlowData;
  const [balanceInstructionData] = useState<IBalanceInstruction[]>(balanceInstructions || []);
  const { isAdmin } = useAdminModeStore();
  const nextClick = async () => {
    await updateBalanceFlowData({
      ...balanceFlowData,
      status: isAdmin ? balanceFlowData.status : 'pending',
    });

    setCurrentStepIndex((prevStep) => prevStep + 1);
  };
  return (
    <div className=" flex-col flex-1 flex  overflow-y-auto justify-between  ">
      <div className="flex flex-col space-y-4 ">
        <h2 className="text-lg">Execution recommendations</h2>
        <div className="flex flex-1  max-w-[40rem]">
          <ExecutionDealCharacteristics balanceInstructions={balanceInstructionData} />
        </div>
        <div className="border opacity-50"></div>
        <h6 className="text-red  ">Executed protections</h6>
        <div className=" flex max-h-[20rem] border border-gray-150 ">
          {balanceInstructions && (
            <ExecutionTable tableData={balanceInstructionData.map((item) => ({ ...item, status: 'pending' }))} />
          )}
        </div>
        <UnderTableButtons />
      </div>
      <div className=" flex flex-row  space-x-4 ">
        <div>
          <ButtonDesigned
            backButton
            className="py-2 "
            style="outline"
            onButtonClick={() => setCurrentStepIndex((currIndex) => currIndex - 1)}
          ></ButtonDesigned>
        </div>
        <ButtonDesigned disableButton={!balanceInstructionData} onButtonClick={nextClick} className="mt-auto">
          Next <ChevronRightIcon />
        </ButtonDesigned>
      </div>
    </div>
  );
};

const UnderTableButtons = () => {
  const demoModeWarning = () => {
    toast.info('Not Available in demo mode');
  };

  return (
    <div className="flex justify-between ">
      <ButtonDesigned
        disableButton={true}
        style="outline"
        onButtonClick={() => {
          demoModeWarning();
        }}
      >
        <div className="flex gap-2">
          <ShareIcon fontSize="small" />
          Send to broker
        </div>
      </ButtonDesigned>
      <div className="space-x-6">
        <ButtonDesigned
          disableButton={true}
          style="outline"
          onButtonClick={() => {
            demoModeWarning();
          }}
        >
          <div className="flex gap-2">
            <img src="../assets/icons/blue-flat/download.svg" />
            Download instructions
          </div>
        </ButtonDesigned>
        <ButtonDesigned
          disableButton={true}
          style="outline"
          onButtonClick={() => {
            demoModeWarning();
          }}
        >
          <div className="flex gap-2">
            <img src="../assets/icons/blue-flat/download.svg" />
            Download certificate
          </div>
        </ButtonDesigned>
      </div>
    </div>
  );
};
